import { Instance, applySnapshot, flow, getParent, types } from 'mobx-state-tree';

import { deleteRubric, getRubric, updateRubric } from '@common/api/rubrics';
import RubricCriterion from '@common/models/Rubrics/RubricCriterion';

const ProgramModel = types.model('Program', {
	id: types.identifierNumber,
	name: types.optional(types.string, ''),
	official_name: types.optional(types.string, ''),
	service_id: types.optional(types.number, 0),
});

const LessonModel = types.model('Lesson', {
	id: types.identifierNumber,
	name: types.optional(types.string, ''),
	program: types.maybeNull(ProgramModel),
});

const RubricGroup = types
	.model('Rubric', {
		id: types.identifierNumber,
		name: types.optional(types.string, ''),
		rubrics: types.optional(types.array(RubricCriterion), []),
		lessons: types.optional(types.array(LessonModel), []),
		assessment_type_id: types.maybeNull(types.number),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getRubric(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),

		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield updateRubric(self.id, data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),

		remove: flow(function* () {
			self.loading = true;
			try {
				yield deleteRubric(self.id);
				const parent: any = getParent(self, 2);
				parent.removeItem(self);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default RubricGroup;

export interface IRubricGroupModel extends Instance<typeof RubricGroup> {}
